import Vue from 'vue'
import socketio from 'socket.io-client'
import VueSocketio from 'vue-socket.io'
import { globalConfig } from '@/config'
import store from '../store/index'

Vue.use(
    VueSocketio,
    socketio(`${globalConfig.socketUrl}`, {
        transports: ['websocket'],
    }),
    store,
)
